import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from "./body-scroll-lock.js";


$(".header .header__overlay").click(function(event) {
  headerLocationMenuToggle("hide");
  $(".header .header__primary-nav .header__select-location-button").focus();
});

$(".header .header__tertiary-nav .header__location-links .role-button").click(function(event) {
    event.preventDefault();
    headerLocationSubmenuToggle("show", $(this).siblings('.header__location-links-submenu'));
});

$(".header .header__tertiary-nav .header__back-button").click(function(event) {
  headerLocationSubmenuToggle("hide", $(this).parent());
});

$(".header .header__primary-nav .header__select-location-button").click(function(event) {
  if($(".header").hasClass("location-menu-show")) {
    headerLocationMenuToggle("hide");
  } else {
    headerLocationMenuToggle("show");
  }
});

$(".header__tertiary-nav__FocusGuard").focus(function(event) {
  headerLocationMenuToggle("hide");
  $(".header .header__primary-nav .header__select-location-button").focus();
});

$(".header__location-links-submenu__FocusGuard").focus(function(event) {
  headerLocationSubmenuToggle("hide", $(".header__location-links-submenu:visible"));
  $(this).siblings("button:visible").focus();
});

// CSS animation callback
function whichTransitionEvent() {
  var t,
    el = document.createElement("fakeelement");

  var transitions = {
    transition: "transitionend",
    OTransition: "oTransitionEnd",
    MozTransition: "transitionend",
    WebkitTransition: "webkitTransitionEnd"
  };

  for (t in transitions) {
    if (el.style[t] !== undefined) {
      return transitions[t];
    }
  }
}

function headerLocationMenuToggle(action) {
  var transitionEvent = whichTransitionEvent();
  if(action === "show") {
    var targetElement = document.querySelector(".header .header__tertiary-nav"); 
    $(".header .header__primary-nav .header__select-location-button").attr("aria-expanded","true");
    $(".header .header__tertiary-nav").attr("aria-hidden","false").removeClass('hidden--visibility');
    disableBodyScroll(targetElement);
    $(".header").addClass("location-menu-show");
    $(".header__links-container").height($(".header__location-links").height());
    $('.wrap, .footer, .header .header__secondary-nav').attr("aria-hidden","true");
    $(".header .header__tertiary-nav").one(transitionEvent, function(e) {
      // $(".header .header__tertiary-nav .header__location-links > ul > li > a:visible").eq(0).focus();
    });
  } else {
    var targetElement = document.querySelector(".header .header__tertiary-nav");  
    $(".header .header__primary-nav .header__select-location-button").attr("aria-expanded","false");
    enableBodyScroll(targetElement);
    $(".header").removeClass("location-menu-show");
    $('.wrap, .footer, .header .header__secondary-nav').attr("aria-hidden","false");
    $(".header .header__tertiary-nav").one(transitionEvent, function(e) {
      if(!$(".header").hasClass("location-menu-show")) {
        headerLocationSubmenuToggle("hide", $(".header__location-links-submenu"), false);
        $(".header .header__tertiary-nav").attr("aria-hidden","true").addClass('hidden--visibility');
        // focusElement.focus();
      }
    });
  }
}

function headerLocationSubmenuToggle(action, submenu, refocus = true) {
  var transitionEvent = whichTransitionEvent();
  var submenuHeight = submenu.height();
  if(action === "show") {
    $(".header").addClass("location-submenu-show");
    // $(".header .header__primary-nav .header__select-location-button").attr("aria-expanded","false");
    $(".header__location-links-submenu, .header__location-links-submenu__FocusGuard").addClass('hidden--display');
    submenu.removeClass('hidden--display');
    submenu.siblings().removeClass('hidden--display');
    $(".header__links-container").height(submenuHeight);
    submenu.siblings("button:visible").attr("aria-expanded","true");
    $(".header__links-container").one(transitionEvent, function(e) {
      if(refocus) {
        if($(".header").hasClass("location-submenu-show")) {
          submenu.find(".header__back-button").focus();
        }
      }
    });
  } else {
    $(".header").removeClass("location-submenu-show");
    $(".header__links-container").height($(".header__location-links").height());
    $(".header__links-container").one(transitionEvent, function(e) {
      if(!$(".location-submenu-show").hasClass("location-submenu-show")) {
        $(".header__location-links-submenu, .header__location-links-submenu__FocusGuard").addClass('hidden--display');
        $(".header .header__tertiary-nav .header__location-links .role-button").attr("aria-expanded","false");
        if(refocus) {
          submenu.parent().siblings("button:visible").focus();
        }
      }
    });
  }
}

// Escape key closes modals/nav
$(document).keyup(function(e) {
  if (e.keyCode == 27) {
    if($(".header").hasClass("location-menu-show")) {
      headerLocationMenuToggle("hide");
    }
  }
});
